import chn from './chn/index'
import en from './en/index'

export default {
  chn: {
    translation: {
      ...chn
      // tab1: chn.tab1,
      // menu: chn.menu
    }
  },
  en: {
    translation: {
      ...en
      // tab1: en.tab1,
      // menu: en.menu
    }
  },
  fr: {
    translation: {
      tab1: {
        "title": "Bienvenue à React et react-i18next"
      }
    }
  }
}